import dayjs from "dayjs";
import isToday from "dayjs/plugin/isToday";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/it";
import EmblaCarousel from "embla-carousel";

dayjs.extend(relativeTime);
dayjs.extend(isToday);
dayjs.locale("it"); // use locale globally

// Promise chain
const liveContainer = document.querySelector("#_custom_live_calendar");
if (liveContainer?.dataset.tag_id) {
	fetch(`/misc/custom-live-calendar/${liveContainer.dataset.tag_id}/`, {
		headers: {
			"X-Requested-With": "XMLHttpRequest",
		},
		cache: "no-cache",
	})
		.then((response) => response.json())
		.then((data) => {
			if (data.objects.length) {
				const calendar = document.querySelector("#_custom_live_calendar");
				const live_tpl = calendar.querySelector("#_live_tpl");
				const calendar_list = calendar.querySelector(".embla__container");
				const now = dayjs();
				let start_carousel = 0;

				for (const live of data.objects) {
					const div = live_tpl.cloneNode(true);
					div.removeAttribute("id");
					const detail = div.querySelector("._live_detail");
					const image = div.querySelector("._live_image");
					const live_recap = detail.querySelector("._live_recap");
					const live_date = dayjs(live.date, "YYYY-MM-DD HH:mm");

					if (live.is_past) {
						// container classes
						div.classList.add("past");
						live_recap?.classList.remove("d-none");
					} else if (live_date.isToday()) {
						div.classList.add("today");
					}

					if (live.is_active) {
						div.classList.add("active");
						detail.querySelector("._live_on_air").classList.remove("d-none");
					}

					// container dataset
					div.dataset.live_date = live.is_active_date;
					div.dataset.live_end_date = live.end_date;

					if (
						image &&
						live.image_url &&
						liveContainer.dataset.homepage === "0"
					) {
						// live image
						const img = image.querySelector("img");
						img.setAttribute("src", live.image_url);
						img.setAttribute("alt", live.name);
					} else if (image) {
						div.removeChild(image);
					}

					detail.querySelector("time.date").innerText = `${dayjs(
						live.date,
					).format("DMMM")}`;
					detail.querySelector("time.hours").innerText = `${dayjs(
						live.date,
					).format("HH:mm")}`;

					let live_url = "";
					if (live.is_active) {
						live_url = "/live/";
					} else if (live.linked_content) {
						live_url = live.linked_content;
					}

					if (live_url) {
						detail.querySelector("p._live_name").innerHTML = `
                <a class="stretched-link text-decoration-none" href="${live_url}">
                  ${live.name}
                </a>`;
					} else {
						detail.querySelector("p._live_name").innerText = live.name;
					}

					// showing container
					div.classList.add("d-flex");
					calendar_list.appendChild(div);
				}

				if (live_tpl.parentNode !== null) {
					live_tpl.parentNode.removeChild(live_tpl);
				}

				// indice della live da cui parte il carosello
				for (const [index, element] of document
					.querySelectorAll(".embla__container .event")
					.entries()) {
					const live_date = dayjs(
						element.dataset.live_date,
						"YYYY-MM-DD HH:mm",
					);
					const end_date = dayjs(
						element.dataset.live_end_date,
						"YYYY-MM-DD HH:mm",
					);
					if (live_date <= now && end_date > now) {
						start_carousel = index;
						break;
						// biome-ignore format lint: reason=
					} else if (live_date >= now) {
						start_carousel = index;
						break;
					}
				}
				if (start_carousel === 0) {
					// non ci sono eventi presenti/futuri
					start_carousel = data.objects.length - 1;
				}
				// focus sulla live precedente a quella in corso
				start_carousel -= 1;
				if (start_carousel < 0) {
					start_carousel = 0;
				}

				// Grab wrapper nodes
				const rootNode = document.querySelector(".embla");
				const viewportNode = rootNode.querySelector(".embla__viewport");

				// Grab button nodes
				const prevButtonNode = rootNode.querySelector(".embla__button--prev");
				const nextButtonNode = rootNode.querySelector(".embla__button--next");

				const toggleNavButtons = (carousel) => {
					if (carousel.canScrollNext()) {
						nextButtonNode.removeAttribute("disabled");
					} else {
						nextButtonNode.setAttribute("disabled", "disabled");
					}
					if (carousel.canScrollPrev()) {
						prevButtonNode.removeAttribute("disabled");
					} else {
						prevButtonNode.setAttribute("disabled", "disabled");
					}
				};

				const carousel = EmblaCarousel(viewportNode, {
					align: "start",
					loop: false,
					startIndex: start_carousel,
					dragFree: false,
					skipSnaps: true,
				});

				// DEBUG
				// console.log(start_carousel);
				// carousel.on("slidesInView", () => {
				// 	const slides = carousel.slidesInView();
				// 	console.log(data.objects.length);
				// 	console.log(slides);
				// 	for (const slide of slides) {
				// 		console.log(data.objects[slide]);
				// 	}
				// });
				carousel
					.on("select", toggleNavButtons)
					.on("init", toggleNavButtons)
					.on("reInit", toggleNavButtons);

				// Add click listeners
				prevButtonNode.addEventListener(
					"click",
					() => {
						toggleNavButtons(carousel);
						if (carousel.canScrollPrev()) {
							return carousel.scrollPrev();
						}
					},
					false,
				);
				nextButtonNode.addEventListener(
					"click",
					() => {
						toggleNavButtons(carousel);
						if (carousel.canScrollNext()) {
							return carousel.scrollNext();
						}
					},
					false,
				);
			}
		})
		.catch((error) => {
			console.warn(error);
		});
}
